import * as React from "react";
import styled from "styled-components";
import { Color } from "@glossy/colors";
import { Radius } from "@glossy/radii";
import TextArea from "@komon/form/textarea";
import { Locale } from "@linkfluence/models/locale";
import Loading from "@ui-kit/loader/caterpillar";
import Modal from "@ui-kit/modal";
import { tr } from "@radarly/i18n";
import { Project } from "@radarly/models/project";

const LoadingContainer = styled.div`
  height: 200px;
  position: relative;
`;

const Body = styled.div`
  position: relative;
  line-height: normal;
  color: ${Color.DimGrey};
  background-color: ${Color.White};
  border-radius: ${Radius.Small};
  border: solid 1px ${Color.VeryLightGrey};
  margin: 16px 32px;
`;

const Form = styled.table`
  width: 100%;
  border-spacing: 8px;
  border-collapse: initial;
  padding: 16px;

  th {
    text-align: left;
    width: 1px;
    font: inherit;
    padding: 8px 4px;
  }

  textarea {
    resize: vertical;
    height: 96px;
  }
`;

const Subject = styled.tr`
  font-weight: bold;
`;

export interface IProps {
  from: string;
  locale: Locale;
  onCancel: () => void;
  contactProjectManager: (
    project: Project,
    subject: string,
    content: string
  ) => void;
  project: Project;
  email: string;
  loading?: boolean;
}

const ContactManagerModal = ({
  from,
  locale,
  onCancel,
  contactProjectManager,
  project,
  email,
  loading,
}: IProps) => {
  const subject = tr(locale, "FORM.MAIL_SUBJECT");
  const [content, setContent] = React.useState("");
  return (
    <Modal
      title={tr(locale, "DASHBOARDS.OVERVIEW.PROJECT_ACCOUNT_MAIL_MODAL_TITLE")}
      drawing="user-enveloppe"
      validateLabel={tr(locale, "FORM.SEND")}
      onValidate={() => {
        contactProjectManager(project, subject, content);
        onCancel();
      }}
      onCancel={onCancel}
      isValid={content !== ""}
      locale={locale}
    >
      <Body>
        {loading ? (
          <LoadingContainer>
            <Loading locale={locale} />
          </LoadingContainer>
        ) : (
          <Form>
            <tbody>
              <tr>
                <th>{tr(locale, "FORM.MAIL_TO")}</th>
                <td>{email}</td>
              </tr>
              <tr>
                <th>{tr(locale, "FORM.MAIL_FROM")}</th>
                <td>{from}</td>
              </tr>
              <Subject>
                <th>{subject}</th>
                <td>
                  {tr(
                    locale,
                    "DASHBOARDS.OVERVIEW.PROJECT_ACCOUNT_INFOS_MAIL_SUBJECT",
                    {
                      projectName: project.label,
                    }
                  )}
                </td>
              </Subject>
              <tr>
                <td colSpan={2}>
                  <TextArea
                    onChange={(event) => setContent(event.target.value)}
                    placeholder={tr(locale, "FORM.MESSAGE_PLACEHOLDER")}
                    content={content}
                    icon="pencil"
                    minHeight={50}
                  />
                </td>
              </tr>
            </tbody>
          </Form>
        )}
      </Body>
    </Modal>
  );
};

export default ContactManagerModal;
